import { useEffect, useRef } from 'react';
import IntroVideo from '../../assets/videos/eyeline_intro_web.mp4';

export default function Intro({onEnd}) {
    const introEl = useRef(null);
    const videoEl = useRef(null);

    useEffect(() => {
        const video = videoEl.current;
        const intro = introEl.current;
        if (!video) return;

        // making sure video is muted for Autoplay
        video.muted = true;

        const handleEnded = () => {
            introEl.current.classList.add("off");
            setTimeout(function() {
                if (onEnd) onEnd();
            }, 500);
            
        };

        video.addEventListener("ended", handleEnded);
        intro.addEventListener("click", handleEnded);

        // Clean up on unmount
        return () => {
            video.removeEventListener("ended", handleEnded);
        };
    }, [onEnd]);

    return (
        <div id="intro" className="intro" ref={introEl}>
            <video ref={videoEl} autoPlay={true} muted={true} playsInline={true}>
                <source src="https://videos.ctfassets.net/8omjzwe2j7zb/6RNnDIC8lYesxKvi0Jzag9/f7f4d4339993c7292ed0e93dbd7a50eb/eyeline_intro_web.mp4" type="video/mp4" />
                Your browser does not support the video tag.
            </video>
        </div>
    );
}
